/**
 * Bug #754
 * @Author Aby Joseph
 * @Date 03 Feb 2021
 */
 import axios from "axios";
 import { API_PATIENT_SIGNOUT } from 'api/endpoint';
 import { getPlatform } from "shared/utils/common-utils";
 import local from 'store2';
  
  export const signOutUser = (data) => {
    //return axios.post(API_PATIENT_SIGNOUT, {params:{authUserId:data}});
    /**Bug #952 - Signout issue fix - sign out issue in mobile app even when signed out from web @Author Aby Joseph @Date 24 Jun 2022 */
    let refreshToken = local.get('refreshToken');
    return axios.post(API_PATIENT_SIGNOUT, {refreshToken:refreshToken, platform: getPlatform(), deviceId: local.get("deviceId"),authUserId:data});
    /**Bug #952 - End */
  };
  /*** End ***/